import { useState, useCallback, useEffect } from "react";

export const useEnvelopeStatuses = () => {
  const [envelopeStatuses, setEnvelopeStatuses] = useState(() => {
    const yx_account = localStorage.getItem("yx_account");
    if (!yx_account) {
      return {};
    }
    const storageKey = `envelope_statuses_${yx_account}`;
    try {
      const storedStatuses = localStorage.getItem(storageKey);
      return storedStatuses ? JSON.parse(storedStatuses) : {};
    } catch (e) {
      console.error("Failed to parse envelope statuses from localStorage", e);
      return {};
    }
  });

  const updateEnvelopeStatus = useCallback((attach, opened = false) => {
    const yx_account = localStorage.getItem("yx_account");
    if (!yx_account) {
      return;
    }

    const storageKey = `envelope_statuses_${yx_account}`;
    
    // 1. 从 localStorage 读取当前群聊的状态
    let currentStatuses = {};
    try {
      const storedStatuses = localStorage.getItem(storageKey);
      if (storedStatuses) {
        currentStatuses = JSON.parse(storedStatuses);
      }
    } catch (e) {
      console.error("Failed to parse envelope statuses from localStorage", e);
    }

    // 2. 更新状态
    const newStatuses = {
      ...currentStatuses,
      [attach.redenvelope_id]: {
        ...currentStatuses[attach.redenvelope_id],
        data: attach,
        opened: opened,
        timestamp: Date.now(), // 增加或更新时间戳
      },
    };

    // 3. 将新状态写回 localStorage
    try {
      let statusesToSave = newStatuses;
      let jsonString = JSON.stringify(statusesToSave);
      const ONE_MB = 1 * 1024 * 1024;

      // 当存储大小超过1MB时，清理旧数据
      while (new Blob([jsonString]).size > ONE_MB) {
        console.warn("LocalStorage is over 1MB, clearing old data.");
        
        // 将对象转为数组，并根据时间戳排序
        const sortedEntries = Object.entries(statusesToSave).sort(([, a], [, b]) => (a.timestamp || 0) - (b.timestamp || 0));

        // 决定一次清理多少数据，比如 20%
        const itemsToRemoveCount = Math.max(1, Math.floor(sortedEntries.length * 0.2));
        const oldestEntries = sortedEntries.slice(0, itemsToRemoveCount);

        oldestEntries.forEach(([key]) => {
          delete statusesToSave[key];
        });
        
        jsonString = JSON.stringify(statusesToSave);

        // 如果清理后条目为空，则停止以避免死循环
        if (Object.keys(statusesToSave).length === 0) {
          break;
        }
      }

      localStorage.setItem(storageKey, JSON.stringify(statusesToSave));
      // 更新 state 时也使用清理过的数据
      setEnvelopeStatuses(statusesToSave);
      return; // 提前返回，因为 setEnvelopeStatuses 已经调用
    } catch (e) {
      console.error("Failed to set item to localStorage", e);
      // 这里可以添加一些处理逻辑，比如提示用户清理缓存或删除旧数据
    }

    // 4. 更新 React state 以触发 UI 刷新
    setEnvelopeStatuses(newStatuses);
  }, []);

  return { envelopeStatuses, updateEnvelopeStatus };
};
